import { companyDenomination, normalizeDenomination } from "./denomination";
export type MarkingMode = "manual" | "semi_automatic" | "automatic";
export function latestCompanyPolicy(policies: Record<string, unknown>[]): Record<string, unknown> | undefined {
  return policies.reduce<Record<string, unknown> | undefined>((latest, item) =>
    !latest || Number(item.policy_version) > Number(latest.policy_version) ? item : latest, undefined);
}
export function policyMarkingModes(policy?: Record<string, unknown>): MarkingMode[] {
  const supplied = policy?.allowed_marking_modes;
  if (!Array.isArray(supplied) || !supplied.includes("manual")) return ["manual"];
  return (["manual", "semi_automatic", "automatic"] as const).filter(mode => supplied.includes(mode));
}
export function nextCompanyPolicy(hallId: string, policies: Record<string, unknown>[], maximum: number, modes: MarkingMode[], denomination?: string): Record<string, unknown> {
  const latest = latestCompanyPolicy(policies);
  const normalized = normalizeDenomination(denomination ?? companyDenomination(latest));
  if (!normalized) throw new Error("Use AWG, USD/$ or another valid code/symbol.");
  return {
    hall_id: hallId, policy_version: Number(latest?.policy_version ?? 0) + 1,
    effective_at: new Date().toISOString(), allowed_marking_modes: [...modes],
    default_payout_policy: latest?.default_payout_policy ?? "split",
    max_cards_per_wallet_session: maximum,
    wallet_expiry_grace_hours: latest?.wallet_expiry_grace_hours ?? 6,
    sales_close_methods: latest?.sales_close_methods ?? ["fixed_time", "first_accepted_ball"],
    hall_network_required: true,
    denomination_symbol: normalized,
  };
}
